var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "run_notice", style: _vm.Styles }, [
    _c("i", {
      class: ["custom-icon", "custom-icon-" + _vm.value.config.icon_style],
    }),
    _c("div", { ref: "message", staticClass: "message" }, [
      _c(
        "div",
        {
          ref: "text",
          class: ["text", "activeText"],
          style: { animationDuration: _vm.animationDuration },
        },
        [_vm._v(" " + _vm._s(_vm.message[0]) + " ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }